export enum StringPlotType {
    Canary = "Canary",
    Reference = "Reference",
}

export enum PlotType {
    Canary = 1,
    Reference = 2,
}

export enum Status {
    Active = 1,
    Inactive = 2,
}

export enum Platform {
    JohnDeere = "John Deere Operations Center",
    CNHI = "Case IH AFS Connect",
    FieldView = "Climate FieldView",
    FieldNET = "FieldNET",
}

export enum SimulationWeatherYear {
    TEN_YEAR_MEDIAN = "10 Year Median",
    YEAR_2014 = "2014",
    YEAR_2015 = "2015",
    YEAR_2016 = "2016",
    YEAR_2017 = "2017",
    YEAR_2018 = "2018",
    YEAR_2019 = "2019",
    YEAR_2020 = "2020",
    YEAR_2021 = "2021",
    YEAR_2022 = "2022",
    YEAR_2023 = "2023",
    YEAR_2024 = "2024",
}

export enum RxType {
    ZONE = "ZONE",
    VRI = "VRI",
    VRF = "VRF",
}

export enum OnDemandRxType {
    ShortTerm = "SHORT_TERM",
    TwoWeek = "TWO_WEEK",
    FourWeek = "FOUR_WEEK",
    LastApplication = "LAST_APPLICATION",
}

export enum RxFileFormat {
    JohnDeereOpsCenter = "John Deere Ops Center",
    JohnDeereMonitor = "John Deere Monitor",
    AgSenseCommanderVP = "AgSense Commander VP",
    AgSenseFieldCommander = "AgSense Field Commander",
    AgSenseIconLink = "AgSense ICON Link",
    FieldNET = "FieldNET",
    FieldWISE = "FieldWise",
    ValleyVRI = "Valley VRI",
    Other = "Other",
}

export enum ConnectionType {
    User = "user_connections",
    Field = "field_connections",
    IrrigationSystem = "irrigation_system_connections",
}
